import './contentModalVersementJustificatifs.css';

import cniFlashPng from '@/assets/images/cni_flash.png';
import cniFlashWebp from '@/assets/images/cni_flash.webp';
import cniPoucePng from '@/assets/images/cni_pouce.png';
import cniPouceWebp from '@/assets/images/cni_pouce.webp';
import cniRectoPng from '@/assets/images/cni_recto.png';
import cniRectoWebp from '@/assets/images/cni_recto.webp';
import cniVersoPng from '@/assets/images/cni_verso.png';
import cniVersoWebp from '@/assets/images/cni_verso.webp';
import passeportPng from '@/assets/images/passeport.png';
import passeportWebp from '@/assets/images/passeport.webp';
import passeportFlashPng from '@/assets/images/passeport_flash.png';
import passeportFlashWebp from '@/assets/images/passeport_flash.webp';
import passeportPoucePng from '@/assets/images/passeport_pouce.png';
import passeportPouceWebp from '@/assets/images/passeport_pouce.webp';
import BonnesPratiquesPi from '@/components/BonnesPratiquesPi/BonnesPratiquesPi';

const modalTelephoneContent = (
  <>
    <p>
      Une <span className="bolder-text">facture de téléphone mobile à votre nom.</span>
    </p>
    <div className="modalTelephone-content">
      <p className="bolder-text">À défaut une attestation sur l&apos;honneur :</p>
      <p>
        “Je soussigné M.[Nom] [Prénom], atteste être le seul utilisateur de la ligne de téléphone portable n° [06...] et
        être le seul destinataire des messages parvenant sur cette ligne téléphonique.
      </p>
      <p>Fait à [Ville], le [xx/xx/xx]</p>
      <p>Votre signature manuscrite”</p>
    </div>
  </>
);

const modalCniContent = (
  <>
    <p className="bonnes-pratiques-subtitle bolder-text">
      Ces bonnes pratiques sont valables pour toutes les cartes d’identité (ancienne et nouvelle version) et les cartes
      de séjour.
    </p>

    <p className="bonnes-pratiques-text-tips">
      <i className="totem-icon totem-icon-check" />
      Télécharger dans <span className="bolder-text">2 fichiers séparés</span> :
    </p>
    <ul className="bonnes-pratiques-list">
      <li>1 fichier contenant le recto uniquement</li>
      <li>1 autre fichier contenant le verso uniquement.</li>
    </ul>
    <div className="bonnes-pratiques-pi-container">
      <BonnesPratiquesPi
        isValid={true}
        defaultSrc={cniRectoPng}
        webpSrc={cniRectoWebp}
        legende="Une image recto"
        textOverImg="Recto"
      />
      <BonnesPratiquesPi
        isValid={true}
        defaultSrc={cniVersoPng}
        webpSrc={cniVersoWebp}
        legende="Une image verso"
        textOverImg="verso"
      />
    </div>

    <p className="bonnes-pratiques-text-tips">
      <i className="totem-icon totem-icon-check" />
      Télécharger des images ayant <span className="bolder-text">une bonne lisibilité et qui soient bien cadrées.</span>
    </p>
    <ul className="bonnes-pratiques-list">
      <li>1 fichier contenant le recto uniquement</li>
      <li>1 autre fichier contenant le verso uniquement.</li>
    </ul>
    <div className="bonnes-pratiques-pi-container">
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={cniFlashPng}
        webpSrc={cniFlashWebp}
        legende="Pas de flash visible"
      />
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={cniRectoPng}
        webpSrc={cniRectoWebp}
        legende="Pas de lettres illisibles"
        effect="blur"
      />
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={cniPoucePng}
        webpSrc={cniPouceWebp}
        legende="Pas de doigt qui cache"
      />
    </div>

    <p className="bonnes-pratiques-text-tips">
      <i className="totem-icon totem-icon-check" />
      Télécharger des <span className="bolder-text">images en couleur.</span>
    </p>
    <div className="bonnes-pratiques-pi-container">
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={cniRectoPng}
        webpSrc={cniRectoWebp}
        legende="Pas de noir et blanc"
        effect="blackWhite"
      />
    </div>

    <p>
      Veillez à ce que le texte (y compris dans la bande blanche) présent sur votre pièce d’identité soit clair et
      lisible.
    </p>
  </>
);

const modalPasseportContent = (
  <>
    <p className="bonnes-pratiques-text-tips">
      <i className="totem-icon totem-icon-check" />
      Télécharger une <span className="bolder-text">image de qualité</span> :
    </p>

    <div className="bonnes-pratiques-pi-container">
      <BonnesPratiquesPi
        isValid={true}
        defaultSrc={passeportPng}
        webpSrc={passeportWebp}
        legende="Une image de la page avec la photo et la page avec signature"
      />
    </div>

    <p className="bonnes-pratiques-text-tips">
      <i className="totem-icon totem-icon-check" />
      Télécharger des images ayant <span className="bolder-text">une bonne lisibilité et bien cadrées.</span>
    </p>
    <div className="bonnes-pratiques-pi-container">
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={passeportFlashPng}
        webpSrc={passeportFlashWebp}
        legende="Pas de flash visible"
      />
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={passeportPng}
        webpSrc={passeportWebp}
        legende="Pas de lettres illisibles"
        effect="blur"
      />
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={passeportPoucePng}
        webpSrc={passeportPouceWebp}
        legende="Pas de doigt qui cache"
      />
    </div>

    <p className="bonnes-pratiques-text-tips">
      <i className="totem-icon totem-icon-check" />
      Télécharger des <span className="bolder-text">images en couleur.</span>
    </p>
    <div className="bonnes-pratiques-pi-container">
      <BonnesPratiquesPi
        isValid={false}
        defaultSrc={passeportPng}
        webpSrc={passeportWebp}
        legende="Pas de noir et blanc"
        effect="blackWhite"
      />
    </div>

    <p>Veillez à ce que le texte (y compris dans la bande grise) présent sur votre passeport soit clair et lisible.</p>
  </>
);

export { modalTelephoneContent, modalCniContent, modalPasseportContent };
